module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/prototype-glass.2e7ef095.png";